export const icons: Array<{
  name: string;
  categories: string[];
  tags: string[];
}> = [
  {
    name: "album",
    categories: ["photography", "multimedia"],
    tags: ["photo", "book"],
  },
  {
    name: "at-sign",
    categories: ["text", "account"],
    tags: ["mention", "at", "email", "message", "@"],
  },
  {
    name: "atom",
    categories: ["science"],
    tags: [
      "atomic",
      "nuclear",
      "physics",
      "particle",
      "element",
      "molecule",
      "electricity",
      "energy",
      "chemistry",
    ],
  },
  {
    name: "audio-lines",
    categories: ["multimedia", "communication"],
    tags: [
      "graphic equaliser",
      "sound",
      "noise",
      "listen",
      "hearing",
      "hertz",
      "frequency",
      "wavelength",
      "vibrate",
      "sine",
      "synthesizer",
      "synthesiser",
      "levels",
      "track",
      "music",
      "playback",
      "radio",
      "broadcast",
      "airwaves",
      "voice",
      "vocals",
      "singer",
      "song",
    ],
  },
  {
    name: "audio-waveform",
    categories: ["multimedia", "communication"],
    tags: [
      "sound",
      "noise",
      "listen",
      "hearing",
      "hertz",
      "frequency",
      "wavelength",
      "vibrate",
      "sine",
      "synthesizer",
      "synthesiser",
      "levels",
      "track",
      "music",
      "playback",
      "radio",
      "broadcast",
      "airwaves",
      "voice",
      "vocals",
      "singer",
      "song",
    ],
  },
  {
    name: "award",
    categories: ["account", "sports", "gaming"],
    tags: ["achievement", "badge", "rosette", "prize", "winner"],
  },
  {
    name: "badge-check",
    categories: ["social"],
    tags: ["verified", "check"],
  },
  {
    name: "book",
    categories: ["text", "gaming"],
    tags: [
      "dictionary",
      "define",
      "definition",
      "thesaurus",
      "encyclopedia",
      "encyclopaedia",
      "reading",
      "booklet",
      "magazine",
      "leaflet",
      "pamphlet",
      "tome",
      "library",
      "writing",
      "written",
      "writer",
      "author",
      "story",
      "script",
      "fiction",
      "novel",
      "information",
      "knowledge",
      "education",
      "high school",
      "university",
      "college",
      "academy",
      "student",
      "study",
      "learning",
      "homework",
      "research",
      "language",
      "translate",
      "alphabetical",
      "a-z",
      "ordered",
    ],
  },
  {
    name: "book-audio",
    categories: ["multimedia", "text"],
    tags: [
      "audiobook",
      "reading",
      "listening",
      "sound",
      "story",
      "fiction",
      "novel",
      "information",
      "knowledge",
      "education",
      "student",
      "study",
      "learning",
      "research",
    ],
  },
  {
    name: "book-headphones",
    categories: ["multimedia", "text"],
    tags: [
      "audiobook",
      "reading",
      "listening",
      "sound",
      "story",
      "fiction",
      "novel",
      "information",
      "knowledge",
      "education",
      "student",
      "study",
      "learning",
      "research",
    ],
  },
  {
    name: "boom-box",
    categories: ["devices", "multimedia", "social"],
    tags: [
      "radio",
      "speakers",
      "audio",
      "music",
      "sound",
      "broadcast",
      "live",
      "frequency",
    ],
  },
  {
    name: "brush",
    categories: ["text", "design", "tools"],
    tags: ["draw", "paint", "color", "artist"],
  },
  {
    name: "builder-io",
    categories: ["development", "social"],
    tags: [
      "feed",
      "subscribe",
      "news",
      "updates",
      "notifications",
      "content",
      "blog",
      "articles",
      "broadcast",
      "syndication",
      "reader",
      "channels",
      "posts",
      "publishing",
      "digest",
      "alert",
      "following",
      "inbox",
      "newsletter",
      "weblog",
      "podcast",
    ],
  },
  {
    name: "bus",
    categories: ["transportation"],
    tags: ["bus", "vehicle", "transport", "trip"],
  },
  {
    name: "bus-front",
    categories: ["transportation"],
    tags: ["coach", "vehicle", "trip", "road"],
  },
  {
    name: "cake",
    categories: ["food-beverage", "social", "account"],
    tags: [
      "birthday",
      "birthdate",
      "celebration",
      "party",
      "surprise",
      "gateaux",
      "dessert",
      "fondant",
      "icing sugar",
      "sweet",
      "baking",
    ],
  },
  {
    name: "calendar",
    categories: ["time"],
    tags: [
      "date",
      "month",
      "year",
      "event",
      "single",
      "singular",
      "once",
      "1",
      "first",
    ],
  },
  {
    name: "calendar-check",
    categories: ["time"],
    tags: [
      "date",
      "day",
      "month",
      "year",
      "event",
      "confirm",
      "subscribe",
      "schedule",
      "done",
      "todo",
      "tick",
      "complete",
      "task",
    ],
  },
  {
    name: "calendar-days",
    categories: ["time"],
    tags: ["date", "month", "year", "event"],
  },
  {
    name: "calendar-heart",
    categories: ["time"],
    tags: [
      "date",
      "month",
      "year",
      "event",
      "heart",
      "favourite",
      "subscribe",
      "valentines day",
    ],
  },
  {
    name: "camera",
    categories: ["photography", "devices", "communication"],
    tags: ["photo", "webcam", "video"],
  },
  {
    name: "cassette-tape",
    categories: [
      "connectivity",
      "devices",
      "multimedia",
      "communication",
      "files",
    ],
    tags: ["audio", "music", "recording", "play"],
  },
  {
    name: "clapperboard",
    categories: ["multimedia"],
    tags: [
      "movie",
      "film",
      "video",
      "camera",
      "cinema",
      "cut",
      "action",
      "television",
      "tv",
      "show",
      "entertainment",
    ],
  },
  {
    name: "contact-round",
    categories: ["account", "connectivity", "communication", "social"],
    tags: [
      "user",
      "person",
      "family",
      "friend",
      "acquaintance",
      "listing",
      "networking",
    ],
  },
  {
    name: "disc",
    categories: ["devices", "multimedia"],
    tags: [
      "album",
      "music",
      "songs",
      "format",
      "cd",
      "dvd",
      "vinyl",
      "sleeve",
      "cover",
      "platinum",
      "compilation",
      "ep",
      "recording",
      "playback",
      "spin",
      "rotate",
      "rpm",
      "dj",
    ],
  },
  {
    name: "disc-2",
    categories: ["devices", "multimedia"],
    tags: [
      "album",
      "music",
      "vinyl",
      "record",
      "cd",
      "dvd",
      "format",
      "dj",
      "spin",
      "rotate",
      "rpm",
    ],
  },
  {
    name: "disc-3",
    categories: ["devices", "multimedia"],
    tags: [
      "album",
      "music",
      "vinyl",
      "record",
      "cd",
      "dvd",
      "format",
      "dj",
      "spin",
      "rotate",
      "rpm",
    ],
  },
  {
    name: "disc-album",
    categories: ["devices", "multimedia"],
    tags: [
      "album",
      "music",
      "songs",
      "format",
      "cd",
      "dvd",
      "vinyl",
      "sleeve",
      "cover",
      "platinum",
      "compilation",
      "ep",
      "recording",
      "playback",
      "spin",
      "rotate",
      "rpm",
      "dj",
    ],
  },
  {
    name: "earth",
    categories: ["navigation"],
    tags: ["world", "browser", "language", "translate", "globe"],
  },
  {
    name: "gallery-vertical",
    categories: [
      "layout",
      "design",
      "development",
      "photography",
      "multimedia",
    ],
    tags: [
      "carousel",
      "pictures",
      "images",
      "scroll",
      "swipe",
      "album",
      "portfolio",
    ],
  },
  {
    name: "globe",
    categories: ["navigation"],
    tags: ["world", "browser", "language", "translate"],
  },
  {
    name: "guitar",
    categories: ["multimedia"],
    tags: [
      "acoustic",
      "instrument",
      "strings",
      "riff",
      "rock",
      "band",
      "country",
      "concert",
      "performance",
      "play",
      "lead",
      "loud",
      "music",
      "audio",
      "sound",
      "noise",
    ],
  },
  {
    name: "heart",
    categories: [
      "medical",
      "social",
      "multimedia",
      "emoji",
      "gaming",
      "shapes",
    ],
    tags: ["like", "love", "emotion", "suit", "playing", "cards"],
  },
  {
    name: "house",
    categories: ["buildings", "home"],
    tags: ["home", "living", "building", "residence", "architecture"],
  },
  {
    name: "image",
    categories: ["photography", "text", "multimedia", "files"],
    tags: ["picture", "photo"],
  },
  {
    name: "images",
    categories: ["photography", "text", "multimedia", "files"],
    tags: [
      "picture",
      "photo",
      "multiple",
      "copy",
      "gallery",
      "album",
      "collection",
      "slideshow",
      "showcase",
    ],
  },
  {
    name: "laugh",
    categories: ["emoji"],
    tags: ["emoji", "face", "happy", "good", "emotion"],
  },
  {
    name: "layout-dashboard",
    categories: ["design", "layout"],
    tags: ["masonry", "brick"],
  },
  {
    name: "library",
    categories: [
      "text",
      "photography",
      "multimedia",
      "navigation",
      "development",
    ],
    tags: [
      "books",
      "reading",
      "written",
      "authors",
      "stories",
      "fiction",
      "novels",
      "information",
      "knowledge",
      "education",
      "high school",
      "university",
      "college",
      "academy",
      "learning",
      "study",
      "research",
      "collection",
      "vinyl",
      "records",
      "albums",
      "music",
      "package",
    ],
  },
  {
    name: "library-big",
    categories: [
      "text",
      "photography",
      "multimedia",
      "navigation",
      "development",
    ],
    tags: [
      "books",
      "reading",
      "written",
      "authors",
      "stories",
      "fiction",
      "novels",
      "information",
      "knowledge",
      "education",
      "high school",
      "university",
      "college",
      "academy",
      "learning",
      "study",
      "research",
      "collection",
      "vinyl",
      "records",
      "albums",
      "music",
      "package",
    ],
  },
  {
    name: "link",
    categories: ["text", "account"],
    tags: ["chain", "url"],
  },
  {
    name: "link-2",
    categories: ["text", "account"],
    tags: ["chain", "url"],
  },
  {
    name: "list-music",
    categories: ["multimedia"],
    tags: ["playlist", "queue", "music", "audio", "playback"],
  },
  {
    name: "list-video",
    categories: ["multimedia"],
    tags: ["playlist", "video", "playback"],
  },
  {
    name: "martini",
    categories: ["food-beverage"],
    tags: ["cocktail", "alcohol", "beverage", "bar", "drink", "glass"],
  },
  {
    name: "megaphone",
    categories: ["multimedia", "notifications"],
    tags: ["advertisement", "attention", "alert", "notification"],
  },
  {
    name: "mic",
    categories: ["devices", "communication", "connectivity", "multimedia"],
    tags: ["record", "sound", "listen", "radio", "podcast", "microphone"],
  },
  {
    name: "music",
    categories: ["multimedia", "files"],
    tags: ["note", "quaver", "eighth note"],
  },
  {
    name: "music-4",
    categories: ["multimedia", "files"],
    tags: ["semiquaver", "sixteenth note", "note"],
  },
  {
    name: "palette",
    categories: ["text", "design", "photography"],
    tags: [
      "colors",
      "colours",
      "theme",
      "scheme",
      "paint",
      "watercolor",
      "watercolour",
      "artist",
    ],
  },
  {
    name: "party-popper",
    categories: ["emoji"],
    tags: [
      "emoji",
      "congratulations",
      "celebration",
      "party",
      "tada",
      "🎉",
      "🎊",
      "excitement",
      "exciting",
      "excites",
      "confetti",
    ],
  },
  {
    name: "radio",
    categories: ["devices", "multimedia", "social"],
    tags: ["signal", "broadcast", "connectivity", "live", "frequency"],
  },
  {
    name: "shirt",
    categories: ["shopping"],
    tags: ["t-shirt", "shopping", "store", "clothing", "clothes"],
  },
  {
    name: "shopping-cart",
    categories: ["shopping"],
    tags: [
      "trolley",
      "cart",
      "basket",
      "e-commerce",
      "store",
      "purchase",
      "products",
      "items",
      "ingredients",
    ],
  },
  {
    name: "smile",
    categories: ["emoji", "account"],
    tags: ["emoji", "face", "happy", "good", "emotion"],
  },
  {
    name: "star",
    categories: [
      "account",
      "social",
      "shapes",
      "multimedia",
      "weather",
      "emoji",
      "gaming",
    ],
    tags: ["bookmark", "favorite", "like", "review", "rating"],
  },
  {
    name: "store",
    categories: ["buildings", "navigation", "shopping"],
    tags: ["shop", "supermarket", "stand", "boutique", "building"],
  },
  {
    name: "tag",
    categories: ["account"],
    tags: ["label", "badge", "ticket", "mark", "product"],
  },
  {
    name: "ticket",
    categories: ["account", "transportation"],
    tags: [
      "entry",
      "pass",
      "voucher",
      "event",
      "concert",
      "show",
      "perforated",
      "dashed",
    ],
  },
  {
    name: "video",
    categories: ["devices", "communication", "connectivity", "photography"],
    tags: [
      "camera",
      "movie",
      "film",
      "recording",
      "motion picture",
      "camcorder",
      "reel",
    ],
  },
];
